import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useState } from 'react'
import { useAuthFetch } from "../api/authFetch";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import {saveAs} from "file-saver";
import UserSelectDialog from '../components/UserSelectDialog';


export default function DataGridDemo() {

    const authFetch = useAuthFetch();
    const [consentizerId, setConsentizerId] = useState('');
    const [encConsentizerId, setEncConsentizerId] = useState('');
    const [savedMessage, setSavedMessage] = React.useState(false);

    const changeConsentizerId = (event: { target: { value: React.SetStateAction<string>; }; }) => {
      setConsentizerId(event.target.value)
    }

    const changeEncConsentizerId = (event: { target: { value: React.SetStateAction<string>; }; }) => {
      setEncConsentizerId(event.target.value)
    }



    const buttonHandler = async() => {


        if (consentizerId === '' && encConsentizerId === '') return;


        const response = await authFetch(process.env.REACT_APP_USERDELETE_URL +"?consentizerId="+encodeURIComponent(consentizerId)+"&encConsentizerId="+encodeURIComponent(encConsentizerId));
        
        if (response.status) {
          }

      setSavedMessage(true);

    };

    const buttonHandlerLoad = async() => {


      if (consentizerId === '' && encConsentizerId === '') return;


      const response = await authFetch(process.env.REACT_APP_GETUSERDATA_URL +"?consentizerId="+encodeURIComponent(consentizerId)+"&encConsentizerId="+encodeURIComponent(encConsentizerId));
      
      if (response.status) {
          
          var data = await response.blob()
          saveAs(data, `userdata.json`)

        }

    setSavedMessage(true);

  };
    
  const userSelected = (selectedItem: string) => {
    // Handle the selected item
    if (selectedItem !== '')
      setConsentizerId(selectedItem);
  };

  const savedMessageClose = () => {
    setSavedMessage(false);
  }

   
  return (
    <Box sx={{ height: `auto`, width: '100%' }}>
        <Box
            component="form"
            sx={{
            '& .MuiTextField-root': { m: 1, width: '1000' },
            }}
            noValidate
            autoComplete="off"
          >
                <div  style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                <TextField label="ConsentizerId" id="txtConsentizerId" required value={consentizerId} onChange={changeConsentizerId} inputProps={{ style: { width: "600px" }}}
                   />
                <UserSelectDialog
                  onItemSelected={userSelected}
                />
                <TextField label="encConsentizerId" id="txtEncConsentizerId" required value={encConsentizerId} onChange={changeEncConsentizerId} inputProps={{ style: { width: "600px" }}}
                   />
                <Button variant="contained" onClick={buttonHandlerLoad}>Load</Button>
                <Button variant="contained" onClick={buttonHandler}>Delete</Button>

            </div> 
        </Box>
        <Snackbar
        open={savedMessage}
        autoHideDuration={3000}
        onClose={savedMessageClose}
      >
          <Alert severity="success" sx={{ width: '100%' }}>
        Data deleted.
      </Alert>
      </Snackbar>
    </Box>
  );
}